class ListaProdutos {

    main = false
    items = []
	buttons = false
    timesize = false

	constructor(){

        this.main = document.querySelector( '#lista-produtos' )
        if( !this.main ){ return }

        this.items = this.main.querySelectorAll( ':scope > div' )
        if( !this.items.length ){ return }
        
        for( const item of this.items ){
            this.configureItem( item )
        }
        window.addEventListener( 'resize', () => {
            if( this.timesize ){ clearTimeout( this.timesize )}
            this.timesize = setTimeout(() => {
                ListaProdutos.init()
            }, 100 )
        })

	}

    css( element, style ) {
        let __return
        try {
            __return = window.getComputedStyle(element, null).getPropertyValue( style )
        } 
        catch(e) {
            __return = element.currentStyle[style]
        } 
        return __return
    }

    configureItem( item ){

        item.inner = item.querySelector( '.inner' )
        item.toggle = item.querySelector( 'button[data-action="toggle"]' )

        if( item.inner.scrollHeight > ( item.inner.offsetHeight + 5 ) ){

            item.classList.add( 'with-toggle' )
            item.dataset.initialHeight = this.css( item.inner, 'max-height' )

            if( !item.toggle ){
                item.toggle = document.createElement( 'button' )
                item.toggle.classname = 'toggle'
                item.toggle.innerHTML = '<strong>' + this.main.dataset.labelMore +'</strong><svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.04297 1.08643C5.04297 0.810283 4.81911 0.586426 4.54297 0.586426C4.26683 0.586426 4.04297 0.810283 4.04297 1.08643L4.54297 1.08643L5.04297 1.08643ZM4.18942 8.2754C4.38468 8.47066 4.70126 8.47066 4.89652 8.2754L8.0785 5.09342C8.27376 4.89816 8.27376 4.58158 8.0785 4.38631C7.88324 4.19105 7.56666 4.19105 7.3714 4.38631L4.54297 7.21474L1.71454 4.38631C1.51928 4.19105 1.2027 4.19105 1.00743 4.38631C0.812172 4.58158 0.812172 4.89816 1.00743 5.09342L4.18942 8.2754ZM4.54297 1.08643L4.04297 1.08643L4.04297 7.92185L4.54297 7.92185L5.04297 7.92185L5.04297 1.08643L4.54297 1.08643Z" fill="#16DED0"/></svg>'
                item.toggle.addEventListener( 'click', ( event ) => {
                    event.preventDefault()
                    this.toggle( item )
                })
                item.appendChild( item.toggle )
            }

        }
        else {

            item.classList.remove( 'with-toggle' )
            if( item.toggle ){
                item.toggle.remove()
            }
        
        }

    }

	toggle( item ){
		if( item.classList.contains( 'opened' ) ){
			this.close( item )
		}
		else {
			this.open( item )
		}
	}

	open( item ){
        
        item.classList.add( 'opened' )
		item.inner.style.maxHeight = item.inner.scrollHeight + "px";
        item.toggle.querySelector('strong').innerText = this.main.dataset.labelLess
        

    }

	close( item ){
	
        item.classList.remove( 'opened' )
		item.inner.style.maxHeight = item.dataset.initialHeight;
        item.toggle.querySelector('strong').innerText = this.main.dataset.labelMore

	}

}

window.addEventListener( 'DOMContentLoaded', () => {
	setTimeout(() => {
        new ListaProdutos()
    }, 300 )
})